module.exports = __webpack_public_path__ + "img/ad07e65.jpg";